<div>
  <div class="shadow dark:shadow-gray-700 rounded-md bg-white dark:bg-slate-900 sticky top-20">
      <div class="p-6">
          <h5 class="text-lg font-semibold">{{ vestiging.naam }}</h5>
      </div>
      <div class="p-6 border-t border-slate-100 dark:border-t-gray-700">
          <ul class="list-none">
              <li class="flex items-center">
                  <i data-feather="user-check" class="h-5 w-5"></i>

                  <div class="ltr:ml-4 rtl:mr-4">
                      <p class="font-medium">Sed ut perspiciatis:</p>
                      <span class="text-emerald-600 font-medium text-sm">Unde omnis iste</span>
                  </div>
              </li>

              <li class="flex items-center mt-3">
                  <i data-feather="map-pin" class="h-5 w-5"></i>

                  <div class="ltr:ml-4 rtl:mr-4">
                      <p class="font-medium">Locatie:</p>
                      <span class="text-emerald-600 font-medium text-sm">{{ vestiging.straat }} {{ vestiging.huisnummer }}{{ vestiging.toevoeging }}</span>
                      <span class="text-emerald-600 font-medium text-sm">{{ vestiging.gemeente }}</span>
                  </div>
              </li>

              <li class="flex items-center mt-3">
                  <i data-feather="monitor" class="h-5 w-5"></i>

                  <div class="ltr:ml-4 rtl:mr-4">
                      <p class="font-medium">Quis nostrud:</p>
                      <span class="text-emerald-600 font-medium text-sm">Exercitation ullamco</span>
                  </div>
              </li>

              <li class="flex items-center mt-3">
                  <i data-feather="briefcase" class="h-5 w-5"></i>

                  <div class="ltr:ml-4 rtl:mr-4">
                      <p class="font-medium">Lorem ipsum:</p>
                      <span class="text-emerald-600 font-medium text-sm">Dolor sit amet</span>
                  </div>
              </li>
          </ul>
      </div>
  </div>
</div><!--end col-->
